import React from "react";
import {Box, Divider, ToggleButton, ToggleButtonGroup} from "@mui/material";
import LanguageIcon from "@mui/icons-material/Language";
import { useTranslation } from "react-i18next";
import { FALLBACK_LANGUAGE, SUPPORTED_LANGUAGES, SupportedLanguage } from "../../i18n";

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();

  const currentLang = (i18n.resolvedLanguage as SupportedLanguage) || FALLBACK_LANGUAGE;

  const handleChange = (
    event: React.MouseEvent<HTMLElement>,
    newLang: SupportedLanguage | null
  ) => {
    if (newLang && newLang !== currentLang) {
      i18n.changeLanguage(newLang);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        px: 1,
        py: 0.5,
        borderRadius: "20px",
        backgroundColor: "background.paper",
        boxShadow: 1,
      }}
    >
      <LanguageIcon sx={{ color: "text.primary" }} />

      <ToggleButtonGroup
        value={currentLang}
        exclusive
        onChange={handleChange}
        size="small"
        sx={{
          display: "flex",
          alignItems: "center",
          "& .MuiToggleButton-root": {
            border: "none",
            px: 1.5,
            color: "text.secondary",
            borderRadius: "12px",
            transition: "all 0.2s ease",
          },

          "& .MuiToggleButton-root.Mui-selected": {
            color: "text.primary",
            fontWeight: 700,
            backgroundColor: "action.selected",
          },
        }}
      >
        {SUPPORTED_LANGUAGES.map((language, index) => {
          return (
            <>
              <ToggleButton key={`toggle-${language}`} value={language}>{language.toUpperCase()}</ToggleButton>
              {(index != SUPPORTED_LANGUAGES.length - 1) &&
                  <Divider
                      key={`divider-${language}`}
                      orientation="vertical"
                      flexItem
                      sx={{
                        mx: 0.5,
                        borderColor: "divider",
                      }}
                  />
              }
            </>
          )
        })}
      </ToggleButtonGroup>
    </Box>
  );
};

export default LanguageSwitcher;